<template>
  <div>
    <Nav></Nav>
    <b-container fluid class="mt-3">
      <b-row>
        <b-col>
          <h3>TURNOS</h3>
          <p>
            Selecciona los turnos de los que requieras el reporte y presiona el boton ver en pantalla.
          </p>
        </b-col>
      </b-row>
      <b-row>
        <b-col lg="4" md="4" sm="6" class="my-1">
          <b-form-group label="Sucursal:">
            <vu-select
              v-model="sucursal_id"
              :options="sucursalesOptions"
              :reduce="option => option.value"
              label="text"
              placeholder="Seleccionar Sucursal">
            </vu-select>
          </b-form-group>
        </b-col>
        <b-col lg="3" md="4" sm="6" class="my-1">
          <label for="example-datepicker">Fecha Inicial</label>
          <b-form-datepicker v-model="initial_date" class="mb-2"></b-form-datepicker>
        </b-col>
        <b-col lg="3" md="4" sm="6" class="my-1">
          <label for="example-datepicker">Fecha Final</label>
          <b-form-datepicker v-model="end_date" class="mb-2"></b-form-datepicker>
        </b-col>
        <b-col lg="2" md="4" sm="6" class="my-1">
          <b-button variant="success" @click="getActualTurnos">Buscar</b-button>
        </b-col>
        <b-col lg="3" md="4" sm="6" class="my-1">
          <modal-shift-info :shifts="selectedCheck" :sucursal_id="sucursal_id"></modal-shift-info>
        </b-col>
      </b-row>

      <!-- Batch Actions -->
      <b-row v-if="selectedCheck.length > 0" class="mt-2">
        <b-col>
          <b-alert show variant="light" class="d-flex align-items-center justify-content-between py-2">
            <span><strong>{{ selectedCheck.length }}</strong> turno(s) seleccionado(s)</span>
            <b-button-group size="sm">
              <b-button :disabled="loading" variant="outline-primary" @click="batchStockDiscount">
                <i class="fa fa-cog mr-1"></i> Procesar Stock
              </b-button>
              <b-button :disabled="loading" variant="outline-warning" @click="batchValidate">
                <i class="fa fa-check-circle mr-1"></i> Validar
              </b-button>
              <b-button :disabled="loading" variant="outline-info" @click="batchReUpload">
                <i class="fa fa-upload mr-1"></i> Re-subir
              </b-button>
            </b-button-group>
          </b-alert>
        </b-col>
      </b-row>

      <!-- Statistics Cards -->
      <b-row v-if="turnos.length > 0" class="mt-3">
        <b-col cols="6" sm="4" md="4" lg="2">
          <b-card no-body class="bg-primary">
            <b-card-body>
              <b-row>
                <b-col>
                  <b-card-title title-tag="h5" class="text-uppercase text-muted mb-0 text-white">Total Turnos</b-card-title>
                  <span class="h2 font-weight-bold mb-0 text-white">{{ totalTurnos }}</span>
                  <p class="mt-1 mb-0 text-sm text-white" style="visibility: hidden;">
                    <span class="text-white-50">-</span>
                  </p>
                </b-col>
                <b-col md="auto">
                  <i class="fa fa-list-ol fa-2x text-white-50"></i>
                </b-col>
              </b-row>
            </b-card-body>
          </b-card>
        </b-col>
        <b-col cols="6" sm="4" md="4" lg="2">
          <b-card no-body class="bg-success">
            <b-card-body>
              <b-row>
                <b-col>
                  <b-card-title title-tag="h5" class="text-uppercase text-muted mb-0 text-white">Turnos Validados</b-card-title>
                  <span class="h2 font-weight-bold mb-0 text-white">{{ turnosValidados }}</span>
                  <p class="mt-1 mb-0 text-sm text-white">
                    <span class="text-white-50">{{ validadosPercentage }}%</span>
                  </p>
                </b-col>
                <b-col md="auto">
                  <i class="fa fa-check-circle fa-2x text-white-50"></i>
                </b-col>
              </b-row>
            </b-card-body>
          </b-card>
        </b-col>
        <b-col cols="6" sm="4" md="4" lg="2">
          <b-card no-body class="bg-warning">
            <b-card-body>
              <b-row>
                <b-col>
                  <b-card-title title-tag="h5" class="text-uppercase text-muted mb-0 text-white">Turnos Pendientes</b-card-title>
                  <span class="h2 font-weight-bold mb-0 text-white">{{ turnosPendientes }}</span>
                  <p class="mt-1 mb-0 text-sm text-white">
                    <span class="text-white-50">{{ pendientesPercentage }}%</span>
                  </p>
                </b-col>
                <b-col md="auto">
                  <i class="fa fa-clock fa-2x text-white-50"></i>
                </b-col>
              </b-row>
            </b-card-body>
          </b-card>
        </b-col>
        <b-col cols="6" sm="4" md="4" lg="2">
          <b-card no-body class="bg-info">
            <b-card-body>
              <b-row>
                <b-col>
                  <b-card-title title-tag="h5" class="text-uppercase text-muted mb-0 text-white">Stock Procesado</b-card-title>
                  <span class="h2 font-weight-bold mb-0 text-white">{{ stockProcesado }}</span>
                  <p class="mt-1 mb-0 text-sm text-white">
                    <span class="text-white-50">{{ stockProcesadoPercentage }}%</span>
                  </p>
                </b-col>
                <b-col md="auto">
                  <i class="fa fa-box fa-2x text-white-50"></i>
                </b-col>
              </b-row>
            </b-card-body>
          </b-card>
        </b-col>
        <b-col cols="6" sm="4" md="4" lg="2">
          <b-card no-body class="bg-cyan">
            <b-card-body>
              <b-row>
                <b-col>
                  <b-card-title title-tag="h5" class="text-uppercase text-muted mb-0 text-white">Turnos Abiertos</b-card-title>
                  <span class="h2 font-weight-bold mb-0 text-white">{{ turnosAbiertos }}</span>
                  <p class="mt-1 mb-0 text-sm text-white" style="visibility: hidden;">
                    <span class="text-white-50">-</span>
                  </p>
                </b-col>
                <b-col md="auto">
                  <i class="fa fa-unlock fa-2x text-white-50"></i>
                </b-col>
              </b-row>
            </b-card-body>
          </b-card>
        </b-col>
        <b-col cols="6" sm="4" md="4" lg="2">
          <b-card no-body class="bg-danger">
            <b-card-body>
              <b-row>
                <b-col>
                  <b-card-title title-tag="h5" class="text-uppercase text-muted mb-0 text-white">Stock Pendiente</b-card-title>
                  <span class="h2 font-weight-bold mb-0 text-white">{{ stockPendiente }}</span>
                  <p class="mt-1 mb-0 text-sm text-white" style="visibility: hidden;">
                    <span class="text-white-50">-</span>
                  </p>
                </b-col>
                <b-col md="auto">
                  <i class="fa fa-exclamation-triangle fa-2x text-white-50"></i>
                </b-col>
              </b-row>
            </b-card-body>
          </b-card>
        </b-col>
      </b-row>

      <b-row class="mt-3">
        <b-col>
          <b-table :busy="loading" responsive :items="turnos" size="sm" :fields="turnosFields" :per-page="byPage" :current-page="page">
            <template #head(select)>
              <b-form-checkbox :checked="allSelected" @change="toggleSelectAll"></b-form-checkbox>
            </template>
            <template #cell(select)="data">
              <b-form-checkbox v-model="selectedCheck" :value="data.item.id"></b-form-checkbox>
            </template>
            <template #cell(validated_checksum)="data">
              <b-badge :variant="data.item.validated_checksum ? 'success' : 'danger'">
                {{ data.item.validated_checksum ? 'Validado' : 'Pendiente' }}
              </b-badge>
            </template>
            <template #cell(stock_picking_id)="data">
              <b-button
                v-if="data.item.stock_picking_id"
                size="sm"
                variant="success"
                :to="`/movimiento/${data.item.stock_picking_id}`">
                <i class="fa fa-box"></i> {{ data.item.stock_picking_id }}
              </b-button>
              <b-button
                v-else-if="data.item.close_date"
                size="sm"
                variant="outline-primary"
                :disabled="loading"
                @click="stockDiscountShift(data.item.id)">
                <i class="fa fa-cog"></i> Procesar Stock
              </b-button>
              <span v-else class="text-muted">-</span>
            </template>
            <template #cell(buttons)="data">
              <b-button-group size="sm">
                <b-button :disabled="loading" variant="outline-primary" @click="stockDiscountShift(data.item.id)">
                  Stock
                </b-button>
                <b-button :disabled="loading" variant="outline-warning" @click="executeShiftAction('validateShiftChecksum', data.item.id, 'Validado')">
                  Validar
                </b-button>
                <b-button :disabled="loading" variant="outline-info" @click="executeShiftAction('reUploadShift', data.item.id, 'Re-subido')">
                  Re-subir
                </b-button>
              </b-button-group>
            </template>
          </b-table>
        </b-col>
      </b-row>
      <b-row>
        <b-col>
          <b-pagination v-model="page" :total-rows="turnos.length" :per-page="byPage" aria-controls="my-table">
          </b-pagination>
        </b-col>
      </b-row>
    </b-container>
  </div>
</template>
<script>
import Nav from "../components/Nav.vue";
import ModalShiftInfo from "../components/ModalShiftInfo.vue"
import axios from "axios";

export default {
  name: "Turnos",
  components: {
    Nav, ModalShiftInfo
  },

  data() {
    return {
      loading:false,
      sucursal_id: null,
      initial_date: "",
      end_date: "",
      byPage: 15,
      page: 1,
      selectedCheck: [],
      turnos: [],
      sendEmail: false,
      sucursales: [],
      turnosFields: [
        { key: "select", label: "" },
        { key: "id", label: "ID" },
        { key: "open_date", label: "Apertura" },
        { key: "close_date", label: "Cierre" },
        { key: "init_ticket_id", label: "Fol. Inicial" },
        { key: "end_ticket_id", label: "Fol. Final" },
        { key: "validated_checksum", label: "Validado" },
        {key: "stock_picking_id", label: "Stock"},
        { key: "buttons", label: "" },

      ],
    };
  },
  computed: {
    sucursalesOptions() {
      return [...this.sucursales]
        .sort((a, b) => a.nombre.localeCompare(b.nombre))
        .map(sucursal => ({
          value: sucursal.id,
          text: sucursal.nombre
        }));
    },
    allSelected() {
      return this.turnos.length > 0 && this.selectedCheck.length === this.turnos.length;
    },
    // Total number of shifts
    totalTurnos() {
      return this.turnos.length;
    },
    // Validated shifts
    turnosValidados() {
      return this.turnos.filter(turno => turno.validated_checksum === true).length;
    },
    validadosPercentage() {
      if (this.totalTurnos === 0) return 0;
      return ((this.turnosValidados / this.totalTurnos) * 100).toFixed(1);
    },
    // Pending validation shifts
    turnosPendientes() {
      return this.turnos.filter(turno => turno.validated_checksum === false || !turno.validated_checksum).length;
    },
    pendientesPercentage() {
      if (this.totalTurnos === 0) return 0;
      return ((this.turnosPendientes / this.totalTurnos) * 100).toFixed(1);
    },
    // Total closed shifts (for percentage calculations)
    turnosCerrados() {
      return this.turnos.filter(turno => turno.close_date && turno.close_date !== null).length;
    },
    // Stock processed shifts (only count closed shifts)
    stockProcesado() {
      return this.turnos.filter(turno =>
        turno.close_date &&
        turno.close_date !== null &&
        turno.stock_picking_id !== null &&
        turno.stock_picking_id !== undefined
      ).length;
    },
    stockProcesadoPercentage() {
      if (this.turnosCerrados === 0) return 0;
      return ((this.stockProcesado / this.turnosCerrados) * 100).toFixed(1);
    },
    // Open shifts (not closed yet)
    turnosAbiertos() {
      return this.turnos.filter(turno => !turno.close_date || turno.close_date === null).length;
    },
    // Closed shifts without stock processing
    stockPendiente() {
      return this.turnos.filter(turno =>
        turno.close_date &&
        turno.close_date !== null &&
        (!turno.stock_picking_id || turno.stock_picking_id === null)
      ).length;
    }
  },
  watch: {},
  mounted() {
    this.getSucursales()
    this.restoreFiltersFromQuery()
    //this.getActualTurnos();
  },
  created() { },
  methods: {
    restoreFiltersFromQuery() {
      const query = this.$route.query;
      if (query.sucursal_id) {
        this.sucursal_id = parseInt(query.sucursal_id);
      }
      if (query.initial_date) {
        this.initial_date = query.initial_date;
      }
      if (query.end_date) {
        this.end_date = query.end_date;
      }
      // Auto-load results if filters are present
      if (query.sucursal_id && query.initial_date && query.end_date) {
        this.getActualTurnos();
      }
    },
    updateQueryParams() {
      this.$router.push({
        query: {
          sucursal_id: this.sucursal_id,
          initial_date: this.initial_date,
          end_date: this.end_date
        }
      }).catch(() => {}); // Ignore navigation duplicated error
    },
    moneyFormatter(value) {
      return "$" + String(parseFloat(value).toFixed(2))
    },
    nextInput(evt) {
      evt.preventDefault();
      evt.stopPropagation();
      console.log(evt);
      var inputs = document.querySelectorAll(
        'a, button, input, textarea, select, details, [tabindex]:not([tabindex="-1"])'
      );
      for (var i = 0; i < inputs.length; i++) {
        if (
          document.activeElement.id == inputs[i].id &&
          i + 1 < inputs.length
        ) {
          inputs[i + 1].focus();
          break;
        }
      }
    },
    getSucursales() {
      let that = this;
      axios
        .get("/sucursals")
        .then(function (response) {
          that.sucursales = response.data;
        })
        .catch(function (r) {
          that.makeToast("danger", "Error", r.response.data);
        });
    },
    getActualTurnos() {
      let that = this;
      this.selectedCheck = []
      this.updateQueryParams(); // Store filters in URL
      axios
        .get("/shifts?sucursal_id=" + this.sucursal_id + "&initial_date=" + this.initial_date + "&end_date=" + this.end_date)
        .then(function (response) {
          that.turnos = response.data;
        })
        .catch(function (r) {
          that.makeToast("danger", "Error", r.response.data);
        });
    },
    printShifts() {
      let that = this;
      if (this.selectedCheck.length < 1) {
        that.makeToast("danger", "Error", "Selecciona al menos un turno");
        return
      }
      axios
        .post("/shift/cut/print", { shifts: this.selectedCheck, printer_id: 0 })
        .then(function (response) {
          console.log(response.data);
          that.makeToast("success", "Impreso", "Reporte de venta impreso");
        })
        .catch(function (r) {
          that.makeToast("danger", "Error", r.response.data);
        });
      if (this.sendEmail) {
        that.makeToast("success", "Enviando.....", "Enviando correos");
        axios
          .post("/shift/cut/excel", {
            shifts: this.selectedCheck,
            send_mail: true,
          })
          .then(function (response) {
            console.log(response.data);
            that.makeToast("success", "Correos Enviados", "Enviados con exito");
          })
          .catch(function (r) {
            that.makeToast("danger", "Error", r.response.data);
          });
      }
    },
    stockDiscountShift(id) {
      let that=this
      this.loading=true
      axios
        .post("/sucursal/"+this.sucursal_id+"/shift/"+id+"/generateStockMovements")
        .then(function (response) {
          console.log(response.data);
          that.makeToast("success", "Hecho", response.data);
          that.getActualTurnos();
          that.loading=false
        })
        .catch(function (r) {
          that.makeToast("danger", "Error", "turno: "+id+" "+ r.response.data);
          that.loading=false
        });
    },
    executeShiftAction(action, id, successMessage) {
      let that = this
      this.loading = true
      axios
        .post("/sucursal/"+this.sucursal_id+"/action/"+action, id)
        .then(function () {
          that.makeToast("success", successMessage, "Turno "+successMessage+" correctamente");
          that.getActualTurnos();
          that.loading = false
        })
        .catch(function (r) {
          that.makeToast("danger", "Error", "turno: "+id+" "+ r.response.data);
          that.loading = false
        });
    },
    async batchStockDiscount() {
      if (!this.validateBatchSelection()) return
      this.loading = true
      const results = await Promise.allSettled(
        this.selectedCheck.map(id =>
          axios.post("/sucursal/"+this.sucursal_id+"/shift/"+id+"/generateStockMovements")
            .then(response => { this.makeToast("success", "Stock Turno "+id, response.data) })
            .catch(r => { this.makeToast("danger", "Error", "turno: "+id+" "+ (r.response ? r.response.data : r.message)); throw r })
        )
      )
      this.loading = false
      this.getActualTurnos()
      const errors = results.filter(r => r.status === 'rejected')
      if (errors.length === 0) {
        this.makeToast("success", "Listo", "Stock procesado para "+this.selectedCheck.length+" turno(s)")
      }
    },
    async batchValidate() {
      if (!this.validateBatchSelection()) return
      await this.batchExecuteAction('validateShiftChecksum', 'Validar')
    },
    async batchReUpload() {
      if (!this.validateBatchSelection()) return
      await this.batchExecuteAction('reUploadShift', 'Re-subir')
    },
    async batchExecuteAction(action, label) {
      this.loading = true
      const results = await Promise.allSettled(
        this.selectedCheck.map(id =>
          axios.post("/sucursal/"+this.sucursal_id+"/action/"+action, id)
            .then(() => { this.makeToast("success", label, "Turno "+id+" procesado") })
            .catch(r => { this.makeToast("danger", "Error", "turno: "+id+" "+ (r.response ? r.response.data : r.message)); throw r })
        )
      )
      this.loading = false
      this.getActualTurnos()
      const errors = results.filter(r => r.status === 'rejected')
      if (errors.length === 0) {
        this.makeToast("success", "Listo", label+" completado para "+this.selectedCheck.length+" turno(s)")
      }
    },
    toggleSelectAll(checked) {
      this.selectedCheck = checked ? this.turnos.map(t => t.id) : [];
    },
    validateBatchSelection() {
      if (this.selectedCheck.length < 1) {
        this.makeToast("danger", "Error", "Selecciona al menos un turno")
        return false
      }
      if (!this.sucursal_id) {
        this.makeToast("danger", "Error", "Selecciona una sucursal")
        return false
      }
      return true
    },
    makeToast(variant = null, title = "", text = "") {
      this.$bvToast.toast(text, {
        title: title,
        variant: variant,
        solid: true,
        appendToast: true,
        autoHideDelay: 10000,
      });
    },
  },
};
</script>

<style scoped>
/* Mobile optimization for statistics cards */
@media (max-width: 767px) {
  /* Reduce card padding on mobile */
  .bg-primary .card-body,
  .bg-success .card-body,
  .bg-warning .card-body,
  .bg-info .card-body,
  .bg-cyan .card-body,
  .bg-danger .card-body {
    padding: 0.5rem !important;
  }

  /* Smaller title font on mobile */
  .bg-primary .card-title,
  .bg-success .card-title,
  .bg-warning .card-title,
  .bg-info .card-title,
  .bg-cyan .card-title,
  .bg-danger .card-title {
    font-size: 0.65rem !important;
    line-height: 1.2;
  }

  /* Smaller number font on mobile */
  .bg-primary .h2,
  .bg-success .h2,
  .bg-warning .h2,
  .bg-info .h2,
  .bg-cyan .h2,
  .bg-danger .h2 {
    font-size: 1.3rem !important;
  }

  /* Smaller percentage text on mobile */
  .text-sm {
    font-size: 0.65rem !important;
  }

  /* Smaller icons on mobile */
  .fa-2x {
    font-size: 1.1em !important;
  }

  /* Reduce spacing between cards on mobile */
  .mt-3 {
    margin-top: 0.5rem !important;
  }

  /* Reduce margin between columns */
  .col-6 {
    padding-left: 0.25rem !important;
    padding-right: 0.25rem !important;
  }

  /* Reduce margin bottom for cards */
  .col-6 .card {
    margin-bottom: 0.5rem !important;
  }
}

/* Tablet optimization */
@media (min-width: 768px) and (max-width: 991px) {
  .bg-primary .card-body,
  .bg-success .card-body,
  .bg-warning .card-body,
  .bg-info .card-body,
  .bg-cyan .card-body,
  .bg-danger .card-body {
    padding: 1rem !important;
  }

  .bg-primary .card-title,
  .bg-success .card-title,
  .bg-warning .card-title,
  .bg-info .card-title,
  .bg-cyan .card-title,
  .bg-danger .card-title {
    font-size: 0.75rem !important;
  }

  .bg-primary .h2,
  .bg-success .h2,
  .bg-warning .h2,
  .bg-info .h2,
  .bg-cyan .h2,
  .bg-danger .h2 {
    font-size: 1.75rem !important;
  }
}
</style>
